import React from "react";
import { Helmet } from "react-helmet";
import { IMAGES } from "../../utils/constants";
import "./index.scss";

/**
 * @desc Renders a background and title.
 *  - Brand Header (optional)
 *  - Title
 */
export const FunkoFunBackground = ({ children, title = "" }) => {
  // METHODS ------------------------------------------------------------------

  const renderHelmet = () => {
    if (!title) return;
    return (
      <Helmet>
        <title>{title}</title>
      </Helmet>
    );
  };

  // COMPONENT ----------------------------------------------------------------

  const style = {
    background: `url('${IMAGES.FUN_BACKGROUND}') #F3F3F7 50% / contain repeat`,
  };

  return (
    <>
      {renderHelmet()}
      <div className="funko-fun-background" style={style} />
      <div className="container">{children}</div>
    </>
  );
};
